import morph from "../helpers/morph";

class ProductPageMorph extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("variant:changed", (e) => {
      this.renderedVariantId = this.getAttribute("rendered-variant-id");
      const { variant } = e.detail;

      if (!variant || variant.id === this.renderedVariantId) return;

      const variantUrl = new URL(
        window.productUrl(variant.product.handle),
        window.location.origin,
      );

      variantUrl.searchParams.set("variant", window.gidToId(variant.id));

      if (this.morph === "self") {
        variantUrl.searchParams.set("section_id", this.sourceSectionId);
        variantUrl.searchParams.set("view", "add-on");
      }

      this.updateContent(variantUrl);
      this.renderedVariantId = variant.id;
    });
  }

  connectedCallback() {}

  disconnectedCallback() {}

  updateContent(url) {
    const mainContentSelector = "#MainContent";
    const sourceSelector =
      this.morph === "page" ? mainContentSelector : "product-page-morph";

    fetch(url)
      .then((res) => res.text())
      .then((text) => {
        const section = new DOMParser().parseFromString(text, "text/html");
        const targetEl = document
          .createRange()
          .createContextualFragment(
            section.querySelector(sourceSelector).outerHTML,
          );

        if (this.updateUrl) {
          url.searchParams.delete("section_id");
          window.history.replaceState("", "", url);
          document.title = section.title;
        }

        const target =
          this.morph === "page"
            ? document.querySelector(mainContentSelector)
            : this;

        morph(target, targetEl);
      });
  }

  get sourceSectionId() {
    return this.getAttribute("source-section-id");
  }

  get updateUrl() {
    return !window.Shopify.designMode && this.hasAttribute("update-url");
  }

  get morph() {
    return this.getAttribute("morph") || "page";
  }
}

if (!customElements.get("product-page-morph")) {
  customElements.define("product-page-morph", ProductPageMorph);
}
